import axios from 'axios'
import { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { API_URL } from 'src/cms/constants/EndPoint'
import { actions } from './redux/actions'
import { useDispatch, useSelector } from 'react-redux'
import * as auth from './redux/actions'
import { actionTypes } from './redux/constants'
import AuthService from 'src/cms/constants/authService'
import { toAbsoluteUrl } from 'src/cms/helpers'

const Callback = () => {
  const location = useLocation()
  const history = useHistory()
  const dispatch = useDispatch()
  const [error, setError] = useState<string | null>(null)
  const queryParams = new URLSearchParams(location.search)
  const code = queryParams.get('code')
  const state = queryParams.get('state')
  const iss = queryParams.get('iss')
  const stateKey = `oidc.${state}`
  const stateObj = JSON.parse(sessionStorage.getItem(stateKey) || '{}')
  const authResp = useSelector((state: any) => state.auth)
  const code_verifier = stateObj.code_verifier
  const redirect_url = window.__RUNTIME_CONFIG__.REACT_APP_REDIRECT_URL
  const authService = new AuthService()
  const payload = {
    code,
    state,
    iss,
    code_verifier,
    redirect_url,
  }
  useEffect(() => {
    axios
      .post(`${API_URL}/sso/login`, payload)
      .then(async (res) => {
        try {
          const token = res?.data?.data?.token
          await dispatch({ type: actionTypes.LOGIN_SUCCESS, payload: { accessToken: token } })
          // await dispatch(auth.actions.requestUser(token))
          history.push('/dashboard')
        } catch (error) {
          console.error('Login error:', error)
          await authService.logout()
          dispatch(auth.actions.logout())
        }
      })
      .catch((err) => {
        console.error('Login error:', err)
        const message =
          err?.response?.data?.message ||
          err?.response?.data?.error ||
          (err?.response?.status
            ? `SSO login failed with status ${err.response.status}`
            : 'SSO login failed. Please try again.')
        setError(message)
        dispatch(auth.actions.logout())
      })
  }, [])

  const handleBackToLogin = () => {
    window.location.replace('/')
  }

  if (error) {
    return (
      <div className='d-flex flex-column flex-root'>
        <div className='d-flex flex-column flex-column-fluid text-center p-10 py-lg-20'>
          <div className='mb-10 pt-lg-20'>
            <img
              alt='Logo'
              src={toAbsoluteUrl('/media/logos/bank-logo.svg')}
              className='h-50px mb-5'
            />
          </div>
          <div className='pt-lg-10 mb-10'>
            <h1 className='fw-bolder fs-2qx text-gray-700 mb-5'>Login Failed</h1>
            <div className='fw-bold fs-4 text-gray-400 mb-10'>{error}</div>
            <div className='text-center'>
              <button
                type='button'
                className='btn btn-lg btn-primary fw-bolder'
                onClick={handleBackToLogin}
              >
                Back to Login
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return <></>
}

export default Callback
